import { render, staticRenderFns } from "./AdjustBalanceModal.vue?vue&type=template&id=22b2e8fa&scoped=true"
import script from "./AdjustBalanceModal.vue?vue&type=script&lang=js"
export * from "./AdjustBalanceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b2e8fa",
  null
  
)

export default component.exports